import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { map, repeatWhen, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-session-modal',
  templateUrl: './session-modal.component.html',
  styleUrls: ['./session-modal.component.scss'],
  standalone: false,
})
export class SessionModalComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('sessiontimeout') sessiontimeout: TemplateRef<any>;
  @Input() screenChanged: number;
  @Input() timeInSeconds = 1800; // 1800 / 60 = 30 mins
  @Output() sessionEnding: EventEmitter<boolean> = new EventEmitter();
  @Output() extendSessionCallback: EventEmitter<void> = new EventEmitter();
  public count: number;
  public countdown: number;
  private timerSubscription: Subscription;
  private sessionTimer$: Observable<any>;
  private readonly stop$ = new Subject<void>();
  private readonly start$ = new Subject<void>();
  private delay = 1000;

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    this.startTimer();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.screenChanged) {
      this.stop();
      this.start();
    }
  }

  public startTimer(): void {
    this.sessionTimer$ = timer(this.timeInSeconds, this.delay).pipe(
      map((i) => (this.count = i)),
      map(() => (this.countdown = this.timeInSeconds - 1 - this.count)),
      takeUntil(this.stop$),
      repeatWhen(() => this.start$)
    );

    this.timerSubscription = this.sessionTimer$.subscribe((res) => {
      if (this.countdown === 60) {
        // show modal with 60 seconds to go
        this.openModal();
      } else if (this.countdown === 0) {
        this.sessionEnding.emit(true);
        window.scroll(0, 0);
        this.stop();
        location.reload();
      }
    });
  }

  start(): void {
    this.start$.next();
  }

  stop(): void {
    this.stop$.next();
  }

  extendSession(): void {
    this.stop();
    this.start();
    this.modalService.dismissAll();
    this.extendSessionCallback.emit();
  }

  openModal(): void {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      ariaLabelledBy: 'sessionModal',
    };
    if (this.modalService.hasOpenModals()) {
      return;
    }
    this.modalService.open(this.sessiontimeout, ngbModalOptions);
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
